namespace GeniuzPOS.Purchase {
    export interface PoInvoiceReceiveAppForm {
        AppList: PoApprovalEditor;
        SysDocNo: Serenity.StringEditor;
        PurIvNo: Serenity.StringEditor;
        ShopId: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        RefDocNo1: Serenity.StringEditor;
        TaxInvoiceNo: Serenity.StringEditor;
        TaxInvoiceDate: Serenity.DateEditor;
        RefDocNo2: Serenity.StringEditor;
        SupplierId: Serenity.LookupEditor;
        ShipId: Serenity.LookupEditor;
        ShipDate: Serenity.DateEditor;
        WhsId: Serenity.StringEditor;
        VatFg: Serenity.RadioButtonEditor;
        POTypeFg: Serenity.RadioButtonEditor;
        SalesVatTypes: Serenity.LookupEditor;
        DtList: PoInvoiceReceiveAppDtEditor;
        Remark: Serenity.StringEditor;
        TotalAmt: Serenity.DecimalEditor;
        DiscText: Serenity.StringEditor;
        DiscAmt: Serenity.DecimalEditor;
        NetAmt: Serenity.DecimalEditor;
        NetExVat: Serenity.DecimalEditor;
        VatCode: Serenity.LookupEditor;
        VatRate: Serenity.DecimalEditor;
        VatAmt: Serenity.DecimalEditor;
        ExciseTaxAmt: Serenity.DecimalEditor;
        PurInvoiceAmt: Serenity.DecimalEditor;
        CusNetAmtDiff: Serenity.DecimalEditor;
        CusNetAmt: Serenity.DecimalEditor;
        CusVatDiff: Serenity.DecimalEditor;
        CusVatAmt: Serenity.DecimalEditor;
        CusPurInvoiceAmt: Serenity.DecimalEditor;
        NetTotalInVat: Serenity.DecimalEditor;
        CashOrTermfg: Serenity.RadioButtonEditor;
        DepositAmt: Serenity.DecimalEditor;
        PayTermCode: Serenity.LookupEditor;
        DueDate: Serenity.DateEditor;
        PaymentBeforeDisc: Serenity.DecimalEditor;
        PaymentType: Serenity.EnumEditor;
        RefType: Serenity.LookupEditor;
        PaymentDicsRemark: Serenity.StringEditor;
        PaymentDicsAmt: Serenity.DecimalEditor;
        ChequeNo: Serenity.StringEditor;
        ChequeDate: Serenity.DateEditor;
        PaymentAmt: Serenity.DecimalEditor;
        BankId: Serenity.LookupEditor;
        PaymentRefNo: Serenity.StringEditor;
        WhtAmt: Serenity.DecimalEditor;
        CurrencyCode: Serenity.LookupEditor;
        ExchangeRate: Serenity.DecimalEditor;
        CurrencyAmt: Serenity.DecimalEditor;
        PaymentNetAmt: Serenity.DecimalEditor;
        CusCurrencyCode: Serenity.StringEditor;
        CusExchangeRate: Serenity.DecimalEditor;
        CusCurrencyAmt: Serenity.DecimalEditor;
        ReceiptAmt: Serenity.DecimalEditor;
        BalanceAmt: Serenity.DecimalEditor;
        SendForAppfg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
        CheckQty: Serenity.IntegerEditor;
        ApproveFg: Serenity.IntegerEditor;
        PostFg: Serenity.IntegerEditor;
        PostDate: Serenity.DateEditor;
    }

    export class PoInvoiceReceiveAppForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoInvoiceReceiveApp';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoInvoiceReceiveAppForm.init)  {
                PoInvoiceReceiveAppForm.init = true;

                var s = Serenity;
                var w0 = PoApprovalEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.LookupEditor;
                var w4 = s.RadioButtonEditor;
                var w5 = PoInvoiceReceiveAppDtEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.EnumEditor;
                var w8 = s.IntegerEditor;

                Q.initFormType(PoInvoiceReceiveAppForm, [
                    'AppList', w0,
                    'SysDocNo', w1,
                    'PurIvNo', w1,
                    'ShopId', w1,
                    'DocDate', w2,
                    'RefDocNo1', w1,
                    'TaxInvoiceNo', w1,
                    'TaxInvoiceDate', w2,
                    'RefDocNo2', w1,
                    'SupplierId', w3,
                    'ShipId', w3,
                    'ShipDate', w2,
                    'WhsId', w1,
                    'VatFg', w4,
                    'POTypeFg', w4,
                    'SalesVatTypes', w3,
                    'DtList', w5,
                    'Remark', w1,
                    'TotalAmt', w6,
                    'DiscText', w1,
                    'DiscAmt', w6,
                    'NetAmt', w6,
                    'NetExVat', w6,
                    'VatCode', w3,
                    'VatRate', w6,
                    'VatAmt', w6,
                    'ExciseTaxAmt', w6,
                    'PurInvoiceAmt', w6,
                    'CusNetAmtDiff', w6,
                    'CusNetAmt', w6,
                    'CusVatDiff', w6,
                    'CusVatAmt', w6,
                    'CusPurInvoiceAmt', w6,
                    'NetTotalInVat', w6,
                    'CashOrTermfg', w4,
                    'DepositAmt', w6,
                    'PayTermCode', w3,
                    'DueDate', w2,
                    'PaymentBeforeDisc', w6,
                    'PaymentType', w7,
                    'RefType', w3,
                    'PaymentDicsRemark', w1,
                    'PaymentDicsAmt', w6,
                    'ChequeNo', w1,
                    'ChequeDate', w2,
                    'PaymentAmt', w6,
                    'BankId', w3,
                    'PaymentRefNo', w1,
                    'WhtAmt', w6,
                    'CurrencyCode', w3,
                    'ExchangeRate', w6,
                    'CurrencyAmt', w6,
                    'PaymentNetAmt', w6,
                    'CusCurrencyCode', w1,
                    'CusExchangeRate', w6,
                    'CusCurrencyAmt', w6,
                    'ReceiptAmt', w6,
                    'BalanceAmt', w6,
                    'SendForAppfg', w7,
                    'CancelFg', w7,
                    'CheckQty', w8,
                    'ApproveFg', w8,
                    'PostFg', w8,
                    'PostDate', w2
                ]);
            }
        }
    }
}
